module.exports = __webpack_public_path__ + "img/5-5.2bf87a80.svg";